import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Default: localStorage
import {
  authSlice,
  userCourseDetailReducer,
  courseDetailReducer,
  trainingSlice,
  attendenceSlice,
  trainersSlice,
  trainingTypePageSlice,
  trainingSlicePrefetchData,
  calendarSlice,
  traineeApprovalSlice,
  trainingReportsSlice,
  centersSlice,
  branchFeedbackSlice,
  trainingConfigSlice,
  pfConfigSlice,
  trainingBypassSlice,
} from './reducer';
import { encryptTransform } from './encryptTransform';

// Persist Config for authSlice
const authPersistConfig = {
  key: 'authSlice', // Key for localStorage
  storage, // Storage engine
  transforms: [encryptTransform],
  whitelist: ['userData', 'token', 'isAuthenticated', 'loading', 'error'], // State fields to persist
};

// Wrap authSlice with persistReducer
const persistedAuthReducer = persistReducer(authPersistConfig, authSlice);

// Combine all reducers
const rootReducer = combineReducers({
  detailsCourse: courseDetailReducer.reducer,
  userCourseDetail: userCourseDetailReducer.reducer,
  authSlice: persistedAuthReducer, // Persisted auth reducer
  trainingSlice: trainingSlice,
  attendenceSlice: attendenceSlice,
  trainersSlice: trainersSlice,
  trainingTypePageSlice: trainingTypePageSlice,
  trainingSlicePrefetchData: trainingSlicePrefetchData,
  calendarSlice: calendarSlice,
  traineeApprovalSlice: traineeApprovalSlice,
  trainingReportsSlice: trainingReportsSlice,
  centersSlice: centersSlice,
  branchFeedbackSlice: branchFeedbackSlice,
  trainingConfigSlice: trainingConfigSlice,
  pfConfigSlice: pfConfigSlice,
  trainingBypassSlice: trainingBypassSlice,
});

// Configure the store
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Required for Redux Persist
    }),
});

// Persistor for the store
export const persistor = persistStore(store);
